import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostEdc_sharing_groupIdSettlementDraft = z.any()
export type TagsPostEdc_sharing_groupIdSettlementDraft = z.infer<typeof tagsPostEdc_sharing_groupIdSettlementDraft>

export const paramsPostEdc_sharing_groupIdSettlementDraft = z.object({ "groupId": z.string() })
export type ParamsPostEdc_sharing_groupIdSettlementDraft = z.infer<typeof paramsPostEdc_sharing_groupIdSettlementDraft>

export const bodyPostEdc_sharing_groupIdSettlementDraft = z.object({ "from": z.string().date(), "to": z.string().date(), "recipientKey": z.string(), "issueDate": z.string().date(), "dueDate": z.string().date(), "sellerName": z.string().min(1).max(255), "sellerIco": z.string().min(1).max(20), "sellerDic": z.string().max(20).optional(), "sellerAddress": z.string().min(1).max(500), "sellerBankAccount": z.string().min(1).max(100), "buyerName": z.string().min(1).max(255), "buyerIco": z.string().max(20).optional(), "buyerDic": z.string().max(20).optional(), "buyerAddress": z.string().min(1).max(500), "unitPriceWithoutVat": z.number().gte(0).lte(1000000), "vatRate": z.number().gte(0).lte(100) })
export type BodyPostEdc_sharing_groupIdSettlementDraft = z.infer<typeof bodyPostEdc_sharing_groupIdSettlementDraft>

export const responsePostEdc_sharing_groupIdSettlementDraft = z.any()
export type ResponsePostEdc_sharing_groupIdSettlementDraft = z.infer<typeof responsePostEdc_sharing_groupIdSettlementDraft>

interface IPostEdc_sharing_groupIdSettlementDraft extends BaseMethodType {
  tags: TagsPostEdc_sharing_groupIdSettlementDraft,
  params: ParamsPostEdc_sharing_groupIdSettlementDraft,
  body: BodyPostEdc_sharing_groupIdSettlementDraft,
  response: ResponsePostEdc_sharing_groupIdSettlementDraft
}
export const URL = '/edc-sharing/:groupId/settlement/draft'
export const validation = {
  post: {
    tags: tagsPostEdc_sharing_groupIdSettlementDraft,
    params: paramsPostEdc_sharing_groupIdSettlementDraft,
    body: bodyPostEdc_sharing_groupIdSettlementDraft,
    response: responsePostEdc_sharing_groupIdSettlementDraft
  }
}
export interface Edc_sharing_groupIdSettlementDraft extends BaseRouteType {
  post: IPostEdc_sharing_groupIdSettlementDraft
}